// src/components/modalForm/ModalBody.js
import React from 'react';
import './ModalBody.css';

const ModalBody = ({ children, className = '', style }) => {
  return (
    <div className={`modal-body ${className}`.trim()} style={style}>
      {children}
    </div>
  );
};

export default ModalBody;
